import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import LoginSignup from './components/LoginSignup';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';

import Overview from './admin/Overview';
import Partners from './admin/Partners';
import Queries from './admin/Queries';
import Employees from './admin/Employees';
import Reports from './admin/Reports';
import AdminNotifications from './admin/Notifications';
import AdminProfile from './admin/AdminProfile';
import Tasks from './admin/Tasks';
import PartnerDetails from './admin/PartnerDetails';
import EmployeeDetails from './admin/EmployeeDetails';
import TaskDetails from './admin/TaskDetails';
import TestNotifications from './admin/TestNotifications';
import AdminPrivacyPolicy from './pages/AdminPrivacyPolicy';
import DataDeletionRequest from './pages/DataDeletionRequest';

const ProtectedRoute = ({ children }) => {
  const { currentUser, userRole, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-golden"></div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (userRole === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-golden"></div>
      </div>
    );
  }

  if (userRole !== 'admin') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <SidebarProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginSignup />} />

            <Route path="/admin/*" element={
              <ProtectedRoute>
                <Routes>
                  <Route path="/" element={<Navigate to="overview" replace />} />
                  <Route path="overview" element={<Overview />} />
                  <Route path="partners" element={<Partners />} />
                  <Route path="queries" element={<Queries />} />
                  <Route path="employees" element={<Employees />} />
                  <Route path="reports" element={<Reports />} />
                  <Route path="notifications" element={<AdminNotifications />} />
                  <Route path="profile" element={<AdminProfile />} />
                  <Route path="tasks" element={<Tasks />} />
                  <Route path="tasks/:id" element={<TaskDetails />} />
                  <Route path="partners/:id" element={<PartnerDetails />} />
                  <Route path="employees/:id" element={<EmployeeDetails />} />
                  <Route path="test-notifications" element={<TestNotifications />} />
                </Routes>
              </ProtectedRoute>
            } />

            <Route path="/privacy-policy/admin" element={<AdminPrivacyPolicy />} />
            <Route path="/data-deletion-request" element={<DataDeletionRequest />} />

            <Route path="*" element={
              <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                  <h1 className="text-2xl font-bold text-gray-900 mb-2">Page Not Found</h1>
                  <a href="/" className="text-brand-golden hover:underline">Go Home</a>
                </div>
              </div>
            } />
          </Routes>
        </Router>
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;
